import Header from "../Header";
import {Button, Grid, Typography} from "@mui/material";
import React, {useCallback} from "react";
import PropTypes from "prop-types";
import {styled} from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {useNavigate} from "react-router-dom";

const Content = styled("div")(({theme}) => ({
  flexGrow: 1,
  paddingRight: theme.spacing(2),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

function Page({title, showNavigation = false, children, actions}) {
  const navigate = useNavigate()

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate])

  return <Header>
    <Content>
      <div>
        <div style={{marginBottom: "1rem", marginLeft: '1rem', marginRight: '1rem'}}>
          {showNavigation && <Button
            startIcon={<ArrowBackIcon/>}
            onClick={goBack}
            style={{marginLeft: ".5rem", color: "black"}}
          >
            Retour
          </Button>}

          <Grid
            container
            display="flex"
            justifyContent="space-between"
          >
            <Grid item>
              <Typography
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#000"
                }}
              >
                {title}
              </Typography>
            </Grid>

            <Grid item>
              {actions}
            </Grid>
          </Grid>
        </div>


        {children}
      </div>
    </Content>
  </Header>
}

Page.prototype = {
  title: PropTypes.string.isRequired,
  showNavigation: PropTypes.bool,
  children: PropTypes.node,
  actions: PropTypes.node,
}

export default Page;
